import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { userMessagesAtom } from './atoms'
import { InfoDisplay } from '../../components/utility/Containers'
import React from 'react'
import { Box, Button } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { copyToClipboard } from '../../utility'

export function UserMessages() {
  const userMessages = useAtomValue(userMessagesAtom)
  if (!userMessages.length) return null

  return (
    <Box padding="5px">
      <InfoDisplay header={<MessagesHeader />}>
        {userMessages.map((m, i) => (
          <Box key={`${i}:${m}`}>{m}</Box>
        ))}
      </InfoDisplay>
    </Box>
  )
}

function MessagesHeader() {
  const [messages, setUserMessages] = useAtom(userMessagesAtom)
  const doCopy = () => {
    copyToClipboard(messages.join('\n'))
  }
  return (
    <Box display="flex" justifyContent="space-between">
      <Box>Parse Issues: ({messages.length})</Box>
      <Box textAlign="right">
        <Button onClick={doCopy}>
          <ContentCopyIcon />
        </Button>
        <Button onClick={() => setUserMessages([])}>X</Button>
      </Box>
    </Box>
  )
}
